import{__awaiter as t,__generator as e}from"../_virtual/_tslib.js";import i from"./mixins.js";import r from"./base.js";import{withVisible as o,withZIndex as s,withOpacity as n,withZooms as m}from"./common.js";var a=i(r,o(!0),s,n,m).extend({amapMeta:{events:["complete"]},props:{tileSize:{type:Number}},mounted:function(){return t(this,void 0,void 0,(function(){return e(this,(function(t){switch(t.label){case 0:return[4,this.$context.ready];case 1:return t.sent(),this.$context.destroyed?[2]:(this.visible||this.$target.hide(),[2])}}))}))}});export default a;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amap/amap-vue/es/mixins/tile-layer.js
// module id = null
// module chunks = 